import { ChatModel } from '@agent/agent-interface/contact-view/chat/model/chat-model';

export enum ScreenSharingStatus {
  NOT_STARTED = 'NOT_STARTED',
  PENDING_INVITATION = 'PENDING_INVITATION',
  ONGOING = 'ONGOING',
}

export interface ScreenSharingInfoAndChat {
  info: ScreenSharingInfo;
  chat: ChatModel;
}

export class ScreenSharingInfo {
  public get status(): ScreenSharingStatus {
    return this._status || ScreenSharingStatus.NOT_STARTED;
  }

  public get apiKey(): string {
    return this._apiKey || '';
  }

  public get sessionId(): string {
    return this._sessionId || '';
  }

  public get token(): string {
    return this._token || '';
  }

  constructor(private _status?: ScreenSharingStatus, private _apiKey?: string, private _sessionId?: string, private _token?: string) {}

  public askForSharing(): void {
    this._status = ScreenSharingStatus.PENDING_INVITATION;
    this.resetSessionInfo();
  }

  public acceptSharing(apiKey: string, sessionId: string, token: string): void {
    this._status = ScreenSharingStatus.ONGOING;
    this.setSessionInfo(apiKey, sessionId, token);
  }

  public cancelSharing() {
    this._status = ScreenSharingStatus.NOT_STARTED;
    this.resetSessionInfo();
  }

  private resetSessionInfo() {
    this.setSessionInfo();
  }

  private setSessionInfo(apiKey?: string, sessionId?: string, token?: string) {
    this._apiKey = apiKey;
    this._sessionId = sessionId;
    this._token = token;
  }
}
